export default __webpack_public_path__ + "assets/0fd556abe9cd021d25619aac98c22d1a.png";